import type { ComponentProps } from 'react';

const AvatarMother = (props: ComponentProps<'svg'>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    viewBox='0 0 64 64'
    fill="none"
    {...props}
  >
    <path
      fill="#ECF7F6"
      d="M61.333 31.998a29.333 29.333 0 1 1-58.667 0 29.333 29.333 0 0 1 58.667 0Z"
    />
    <path
      fill="#FFBF9F"
      d="M54.51 50.806A29.285 29.285 0 0 1 32.001 61.33a29.238 29.238 0 0 1-21.26-9.121 17.85 17.85 0 0 1 9.967-4.962c.87-.132 1.75-.198 2.63-.197H43.52a17.88 17.88 0 0 1 10.99 3.755Z"
    />
    <path
      fill="#417A7A"
      d="M46.514 42.238a4.373 4.373 0 1 0 0-8.747 4.373 4.373 0 0 0 0 8.747Z"
    />
    <path
      fill="#FFBF9F"
      d="m34.297 11.64-2.201-.007c-5.987-.021-10.858 4.815-10.879 10.803l-.035 10.126c-.021 5.988 4.816 10.858 10.803 10.879l2.201.008c5.987.02 10.858-4.816 10.879-10.803l.035-10.127c.021-5.987-4.815-10.858-10.803-10.879Z"
    />
    <path
      fill="#417A7A"
      d="M45.102 22.52a10.846 10.846 0 0 0-10.805-10.883H32.1a10.847 10.847 0 0 0-10.88 10.799v3.79l8.223-8.93L45.084 30.98"
    />
    <mask
      id="a"
      width={25}
      height={20}
      x={21}
      y={11}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path
        fill="#417A7A"
        d="M45.102 22.52a10.846 10.846 0 0 0-10.805-10.883H32.1a10.847 10.847 0 0 0-10.88 10.799v3.79l8.223-8.93L45.084 30.98"
      />
    </mask>
    <g fill="#5BB0AA" mask="url(#a)">
      <path d="M45.048 28.832 29.512 15.313l-8.87 9.806-.881-.797 9.656-10.674 16.416 14.285-.785.899Zm-9.852-13.558-.764.912 12.233 10.239.764-.913-12.233-10.239Z" />
    </g>
    <path
      fill="#FFBF9F"
      d="M45.53 34.473a3.046 3.046 0 1 0 0-6.093 3.046 3.046 0 0 0 0 6.093Z"
    />
    <path
      fill="#85CFC9"
      d="M29.473 61.224a29.238 29.238 0 0 1-18.73-9.014 17.85 17.85 0 0 1 9.965-4.962l4.95 7.895 3.815 6.081Z"
    />
    <path
      fill="#5BAFA9"
      d="M54.507 50.806A29.285 29.285 0 0 1 31.998 61.33a29.274 29.274 0 0 1-10.787-2.047l4.445-4.165 8.693-8.068h9.168a17.88 17.88 0 0 1 10.99 3.755Z"
    />
    <path
      fill="#263F43"
      d="M36.498 31.488c.679-.04 1.177-.94 1.113-2.01-.064-1.07-.666-1.903-1.345-1.862-.68.04-1.178.94-1.114 2.01.065 1.069.667 1.903 1.346 1.862Zm-10.501.383c.68-.008 1.22-.884 1.207-1.955-.014-1.071-.576-1.933-1.256-1.924-.68.009-1.22.884-1.207 1.955.013 1.072.576 1.933 1.256 1.924Z"
    />
    <path
      fill="#fff"
      d="m30.633 36.58 4.028-2.696s1.785 2.344-.137 3.82c-1.922 1.475-3.891-1.125-3.891-1.125Z"
    />
    <path
      fill="#263F43"
      d="M28.978 35.806c-.393-.381-1.636-1.702-1.19-2.79a1.636 1.636 0 0 1 1.41-.917l-.09-1.339a200.45 200.45 0 0 1-.195-3.266l1.19-.06c.053 1.047.118 2 .202 3.249l.125 1.928a.594.594 0 0 1-.353.578.594.594 0 0 1-.23.052c-.72 0-.928.173-.946.214-.072.19.339.923.928 1.5l-.851.85Z"
    />
  </svg>
);

export default AvatarMother;
